import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Flex, Select, Text } from '@mantine/core';

import { NetworkMapColorLegend } from './NetworkMapColorLegend';
import { ColorMapBy, selectColorMapBy, setColorMapBy } from '../store/slices/clonotypes.slice';
import type { AppState } from '../store/store';

const getColorMapByOptions = (cellFileExists: boolean) => {
  const options = [
    {
      label: 'SHM',
      value: ColorMapBy.SHM,
    },
    {
      label: 'Liabilities',
      value: ColorMapBy.LIABILITY,
    },
    {
      label: 'Clonotype ID',
      value: ColorMapBy.CLONOTYPE_ID,
    },
  ];
  if (cellFileExists) {
    options.push({
      label: 'Leiden cluster',
      value: ColorMapBy.LEIDEN_CLUSTER,
    });
  }
  options.push({
    label: 'Ig isotype',
    value: ColorMapBy.LG_ISO_TYPE,
  });
  return options;
};

export function ColorClonotypeMapBy({ cellFileExists }: { cellFileExists: boolean }) {
  const dispatch = useDispatch();
  const { id: experimentId } = useParams<{ id: string }>();

  const colorMapBy = useSelector((state: AppState) => selectColorMapBy(state, experimentId as string));

  return (
    <Flex align="center" gap="xs" wrap="nowrap" className="shrink-0">
      <Text size="sm" fw={500} style={{ whiteSpace: 'nowrap' }}>
        Color by:
      </Text>
      <Select
        size="xs"
        data-testid="color-clonotype-map-by-selector"
        data={getColorMapByOptions(cellFileExists)}
        value={colorMapBy}
        clearable
        placeholder="Select an attribute"
        onChange={(value) => {
          dispatch(setColorMapBy({ experimentId: experimentId!, colorMapBy: value ? (value as ColorMapBy) : null }));
        }}
      />
      <NetworkMapColorLegend colorMapBy={colorMapBy} />
    </Flex>
  );
}
